// @flow
import React from 'react';
import * as ReportEditingMutation from '../../mutations/ReportEditingStatus';

import './reportEditing.css';

type Props = {
    entityId: string,
    hasEditor?: Function,
    reloadPage?: Function,
    userName: ?string,
    relay: Object,
    parent?: string,
};

type State = {
    open: boolean,
    users: ?string,
    uniqueEditor: boolean,
    firstRequest: boolean,
    intervalId?: any,
    prevLock: boolean,
};

class ReportEditing extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            open: false,
            users: '',
            uniqueEditor: false,
            firstRequest: true,
            prevLock: false,
        };
    }

    componentDidMount() {
        this.onMount();
        this.updateInfo();
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalId);
    }

    onMount = () => {
        const intervalId = setInterval(this.updateInfo, 15000);
        this.setState({ intervalId });
    };

    setStyle = () => {
        const parent = document.getElementById('material-wrapper');
        if (!parent) {
            return null;
        }
        return ({
            left: `${parent.getBoundingClientRect().left}px`,
            width: `${parent.clientWidth}px`,
            marginLeft: 0,
        });
    };

    /**
     * Запускаем интервальные запросы на обновление информации по редактирующим текущий материал
     */
    updateInfo = () => {
        const params = {
            user: this.props.userName,
            object: this.props.entityId,
        };
        ReportEditingMutation.commit(this.props.relay.environment, params, (error, response) => {
            if (response && response.length && !this.state.uniqueEditor) {
                let usersList = '';
                for (let i = 0; i < response.length; i += 1) {
                    if ({}.hasOwnProperty.call(response[i], 'user')) {
                        usersList += `${response[i].user}, `;
                    }
                }
                if (this.props.hasEditor && this.state.firstRequest) {
                    this.props.hasEditor(true);
                }
                usersList = usersList.substring(0, usersList.length - 2);
                this.setState({
                    open: true,
                    users: usersList,
                    prevLock: true,
                });
            } else if (this.props.hasEditor) {
                this.setState({
                    uniqueEditor: true,
                    open: false,
                    users: '',
                });
                if (this.props.hasEditor) {
                    this.props.hasEditor(false);
                }
                if (this.state.prevLock && this.props.reloadPage) {
                    this.props.reloadPage();
                }
            }
            this.setState({ firstRequest: false });
        });
    };

    render() {
        let style = {};
        if (this.props.parent) {
            style = this.setStyle();
        }
        if (this.state.open) {
            return (
                <div className="report-wrapper js-report-wrapper" style={style}>
                    <div className="report--inner">
                        Внимание! Материал редактируется:&nbsp;
                        {this.state.users}
                    </div>
                </div>
            );
        }
        return <div />;
    }
}

export default ReportEditing;



// WEBPACK FOOTER //
// src/components/reportEditing/ReportEditing.js